import { render, staticRenderFns } from "./productList.vue?vue&type=template&id=e2ea753a&"
import script from "./productList.vue?vue&type=script&lang=ts&"
export * from "./productList.vue?vue&type=script&lang=ts&"
import style0 from "./productList.vue?vue&type=style&index=0&id=e2ea753a&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports